import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const getAllBilling = createAsyncThunk('billing/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/invoice/get-client-invoice`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const exportClientInvoice = createAsyncThunk('billing/export-client-invoices', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/invoice/export-client-invoices`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allBilling: [],
  error: null
}

const billingSlice = createSlice({
  name: 'billing',
  initialState,
  reducers: {
    resetAuthState: () => {
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBilling.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllBilling.fulfilled, (state, action) => {
        state.isLoading = false
        state.allBilling = action.payload?.data?.data
      })
      .addCase(getAllBilling.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(exportClientInvoice.pending, (state) => {
        state.isLoading = true
      })
      .addCase(exportClientInvoice.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(exportClientInvoice.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = billingSlice.actions
export default billingSlice.reducer
